import React from 'react'
import styled from 'styled-components'
import ScrollAnimation from 'react-animate-on-scroll'

import { white } from 'styles/colors'
import { media } from 'styles/media'
import { verticalPadding } from 'styles/global'
import { H3, H4, fontWeights, lineHeights } from 'styles/typography'
import * as spacing from 'styles/spacing'

import Section, { SectionBlock } from 'components/Section'
import Wrapper from 'components/Wrapper'

const Container = styled.div`
  position: static;
  text-align: center;
  color: ${white};

  ${media.medium`
    ${verticalPadding`1rem`};
  `};

  ${media.large`
    ${verticalPadding`1.5rem`};
  `};

  ${media.xLarge`
    ${verticalPadding`2rem`};
  `};
`

const List = styled.div`
  display: grid;
  grid-gap: ${spacing.large};
  margin-top: ${spacing.small};

  ${media.small`
    grid-gap: ${spacing.xLarge};
    margin-top: ${spacing.medium};
  `};

  ${media.medium`
    grid-template-columns: repeat(3, 1fr);
    margin-top: ${spacing.large};
  `};
`

const Heading = styled(H3)`
  color: ${white};
  text-align: center;
  text-transform: uppercase;
`

const Feature = styled.div`
  position: static;
  max-width: 340px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 ${spacing.xLarge};

  ${media.medium`
    max-width: none;
    padding: 0 ${spacing.large};
  `};
`

const Label = styled(H4)`
  color: ${white};
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights.base};
`

const Figure = styled.img`
  width: 78px;
  margin-bottom: ${spacing.small};

  ${media.medium`
    width: 86px;
    margin-bottom: ${spacing.medium};
  `};

  ${media.large`
    margin-bottom: ${spacing.medium};
  `};
`

const Features = () => (
  <Container>
    <Section>
      <Wrapper>
        <SectionBlock>
          <ScrollAnimation animateIn="fadeInUp" offset={0} animateOnce>
            <Heading>ENJOY THE PERKS OF FLEXIBILITY</Heading>
          </ScrollAnimation>
        </SectionBlock>
        <SectionBlock>
          <List>
            <Feature as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={200} animateOnce>
              <Figure src={`${process.env.BASE_PATH}/images/subscribe/icons/modify.png`} />
              <Label>Modify the contents of your order whenever you want.</Label>
            </Feature>
            <Feature as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={400} animateOnce>
              <Figure src={`${process.env.BASE_PATH}/images/subscribe/icons/delivery.png`} />
              <Label>Adjust your delivery date and schedule at any time.</Label>
            </Feature>
            <Feature as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={600} animateOnce>
              <Figure src={`${process.env.BASE_PATH}/images/subscribe/icons/cancel.png`} />
              <Label>Cancel or pause your subscription whenever you like.</Label>
            </Feature>
          </List>
        </SectionBlock>
      </Wrapper>
    </Section>
  </Container>
)

export default Features
